import CrudTab from 'react/containers/pages/CrudTab';

class RouteSuggestion extends CrudTab {
  static tabName = 'Greenmile.RouteSuggestion.screenName';

  componentDidMount() {
    let emptySuggestions = new App.Collections.BaseCollection();
    const { suggestions = emptySuggestions, pendingOrder = null } =
      Monet.Session?.RouteSuggestion || {};

    new App.Routers.RouteSuggestion().renderGrid(suggestions, pendingOrder);
  }

  componentDidUpdate() {
    const hasNewDataToRender = Monet.Session?.RouteSuggestion;
    if (hasNewDataToRender) {
      const { suggestions, pendingOrder } = Monet.Session.RouteSuggestion;
      new App.Routers.RouteSuggestion().renderGrid(suggestions, pendingOrder);
    }
  }

  componentWillUnmount() {
    delete Monet.Session?.RouteSuggestion;
  }
}

export default RouteSuggestion;
